import React from "react";
import { Icon } from "office-ui-fabric-react";
import { TimeTrackingLine } from "../../../store/TimeTrackingStore";
import { EntityType } from "../../../entities/common";
import { WithEntityType } from "../TimeTrackingGrid";
import TaskIcon from "../../task/TaskIcon";
import EntityName from "../../views/list/columns/EntityName";
import TimeTrackingAdministrativeCategoryEntityName from "../TimeTrackingAdministrativeCategoryEntityName";
import ApprovalStatusTooltipContent from "./ApprovalStatusTooltipContent";

type Props = {
    timeline: TimeTrackingLine & WithEntityType;
};

const ApprovalStatusTooltip = (props: Props) => {
    const { timeline } = props;
    const timesheetLine = timeline.attributes.TimesheetLine!;

    return (
        <div className="timeline-tooltip time-tracking-tooltip">
            <div className="header">{_renderHeader(timeline)}</div>
            <div className="content">
                <ApprovalStatusTooltipContent
                    approvers={timesheetLine.approvers}
                    decision={timesheetLine.decision}
                />
            </div>
        </div>
    );
};

const _renderHeader = (timeline: TimeTrackingLine & WithEntityType) => {
    if (timeline.attributes.IsAdministrative) {
        if (timeline.entityType === EntityType.Project) {
            return (
                <EntityName
                    name={timeline.attributes.Project.name}
                    iconName="PPMXAdministrativeTime"
                    imageClassName="administrative-time-logo"
                />
            );
        }

        if (timeline.entityType === EntityType.Task) {
            return <TimeTrackingAdministrativeCategoryEntityName categoryId={timeline.attributes.Task.id} />;
        }
    }

    if (timeline.entityType === EntityType.Project) {
        return (
            <EntityName
                name={timeline.attributes.Project.name}
                imageClassName="proj-logo"
                imageId={timeline.attributes.ProjectDetails?.imageId}
                isTimelineView
            />
        );
    }

    if (timeline.attributes.IsCustomEvent) {
        return (
            <EntityName
                name={timeline.attributes.Task.name}
                isTimelineView
                renderLogo={() => (
                    <div className="logo task-logo align-center custom-time-entry-logo">
                        <Icon iconName="StatusCircleCheckmark" className="icon" />
                        <Icon className="person" iconName="PPMXPerson" />
                    </div>
                )}
            />
        );
    }

    return (
        <EntityName
            name={timeline.attributes.Task.name}
            isTimelineView
            renderLogo={() => <TaskIcon entity={timeline.attributes.TaskDetails || ({ externalData: {} } as any)} />}
        />
    );
};

export default ApprovalStatusTooltip;
